// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Video__container-fd07c0 {
  flex: auto;
  border-radius: 8px;
  overflow: hidden;
}

.Video__container-fd07c0 video {
  position: relative;
  object-fit: cover;
  overflow: hidden;
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/SharedComponents/Video/styles.m.css"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  flex: auto;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.container video {\n  position: relative;\n  object-fit: cover;\n  overflow: hidden;\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Video__container-fd07c0`
};
module.exports = ___CSS_LOADER_EXPORT___;
